import React from 'react';
import {
  Show,
  SimpleShowLayout,
  TextField,
  DateField,
  ReferenceArrayField,
  SingleFieldList,
  ChipField,
  EditButton,
  CreateButton,
  ListButton,
  DeleteButton,
} from 'react-admin';
import CardActions from '@material-ui/core/CardActions';

const cardActionStyle = {
  zIndex: 2,
  display: 'inline-block',
  float: 'right',
};

const PromoShowActions = ({ basePath, data }) => (
  <CardActions style={cardActionStyle}>
    <CreateButton basePath={basePath} />
    <EditButton basePath={basePath} record={data} />
    <ListButton basePath={basePath} />
    <DeleteButton basePath={basePath} record={data} />
  </CardActions>
);

const PromoShow = props => (
  <Show {...props} actions={<PromoShowActions />}>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="code" />
      <TextField source="amount" />
      <ReferenceArrayField label="Plans" reference="plans" source="plan_ids">
        <SingleFieldList>
          <ChipField source="name" />
        </SingleFieldList>
      </ReferenceArrayField>
      <DateField source="start_at" showTime />
      <DateField source="end_at" showTime />
    </SimpleShowLayout>
  </Show>
);

export default PromoShow;



// WEBPACK FOOTER //
// ./src/resources/promos/PromoShow.jsx